// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import router from './router'
import store from './store'
import i18n from './constants/lang/i18n'
import { Validator } from 'vee-validate'

Validator.extend('youtubeLink', {
  getMessage: () => '',
  validate: value => /(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
})

require('./plugins/validation')
require('./plugins/localstorage')

Vue.config.productionTip = false

Vue.component('item', {
  template: `
    <li>
      <div class="line-container">
        <div class="line"></div>
      </div>
      <div class="item-container row-block" :class="{ open: tree.type === 'folder' && open && !disabled, selected: selected && !disabled, disabled: disabled }" @click.stop="e => !disabled && toggle()">
        <div class="item-icon" v-if="tree.title">
          <img :src="tree.type === 'folder' ? open ? icons.open : icons.close : selected ? icons.select : icons.file" alt="">
        </div>
        <div :style="{ width: '5px' }"></div>
        <div class="item-title shrink">{{ tree.title }}</div>
        <div :style="{ flex: 1 }"></div>
        <img v-if="tree.type === 'file' && !disabled && options.checkbox !== false" class="item-check" :src="selected ? icons.boxtrue : icons.boxfalse">
      </div>
      <ul v-show="open" v-if="Object.keys(tree.nodes || {}).length > 0 && !disabled">
        <div class="line"></div>
        <item v-for="(node, title, index) in tree.nodes" :key="index" :tree="{ ...node, title: title }" :options="options" :icons="icons" :currentPath="currentPath" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit('select', path)">
        </item>
      </ul>
    </li>
  `,
  props: {
    tree: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: Array,
      required: true
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      open: this.currentPath.includes(this.tree.title) || !this.tree.title
    }
  },
  computed: {
    selected () {
      return this.selectedPaths.includes(this.tree.path)
    },
    disabled () {
      return this.disabledPaths.includes(this.tree.path)
    }
  },
  methods: {
    toggle () {
      switch (this.tree.type) {
        case 'folder': {
          if (this.tree.title) {
            this.open = !this.open
          }
          break
        }
        case 'file': {
          if (this.tree.title) {
            this.$emit('select', this.tree.path)
          }
        }
      }
    }
  }
})

Vue.component('treeList', {
  template: `
    <ul id="root" :class="{ 'no-root': !treeData.title }">
      <item :tree="treeData" :options="options" :icons="icons" :currentPath="(currentPath || '').split('/')" :selectedPaths="selectedPaths" :disabledPaths="disabledPaths" @select="path => $emit('select', path)"></item>
    </ul>
  `,
  props: {
    treeData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    icons: {
      type: Object,
      required: true
    },
    currentPath: {
      type: String,
      default: () => ''
    },
    selectedPaths: {
      type: Array,
      required: true
    },
    disabledPaths: {
      type: Array,
      required: true
    }
  }
})

Vue.use(VueMeta)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js